function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 1666.67 2500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M416.67,2500c230,0,416.67-186.67,416.67-416.67v-416.67h-416.67C186.67,1666.67,0,1853.33,0,2083.33s186.67,416.67,416.67,416.67Z",
    style: {
      fill: "#0acf83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M0,1250c0-230,186.67-416.67,416.67-416.67h416.67v833.33h-416.67C186.67,1666.67,0,1480,0,1250Z",
    style: {
      fill: "#a259ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill1",
    "data-name": "path1_fill",
    d: "M0,416.67C0,186.67,186.67,0,416.67,0h416.67v833.33h-416.67C186.67,833.33,0,646.67,0,416.67Z",
    style: {
      fill: "#f24e1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M833.33,0h416.67c230,0,416.67,186.67,416.67,416.67s-186.67,416.67-416.67,416.67h-416.67V0Z",
    style: {
      fill: "#ff7262"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M1666.67,1250c0,230-186.67,416.67-416.67,416.67s-416.67-186.67-416.67-416.67,186.67-416.67,416.67-416.67,416.67,186.67,416.67,416.67Z",
    style: {
      fill: "#1abcfe"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "figma.svg";
export { ForwardRef as ReactComponent };